import MemberOrder from "./-memberOrder";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/business/memberOrder")({
  staticData: {
    menuLabel: "会员订单",
    showInMenu: true,
    menuGroup: "/business",
    menuOrder: 1,
  },
  component: MemberOrder,
});
